// Custom SVG matching lucide-react's stroke style. Arched headstone
// silhouette, ground line, small cross — fits the CCAANZ context.
// Use like a lucide icon: <TombstoneIcon className="w-4 h-4" />.
export function TombstoneIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M7 21V11a5 5 0 0 1 10 0v10" />
      <path d="M4 21h16" />
      <path d="M12 13v4" />
      <path d="M10 15h4" />
    </svg>
  );
}
